export const environment = {
  production: false,
  apiUrl: 'https://1b5lrixz4b.execute-api.us-east-1.amazonaws.com',
  appUrl: 'http://localhost:4200',
  marketingUrl: 'https://dev.kernalhq.com',
  dashboardUrl: 'https://dev.kernalhq.app',
  adminUrl: 'https://admin.dev.kernalhq.app',
  cognitoRegion: 'us-east-1',
  cognitoUserPoolId: 'us-east-1_YJzqdR45H',
  cognitoClientId: '7p52m7hn13lvh8sovjihqe7bt3',
  googleAnalyticsId: 'G-2Q4RP8ZTHP', // non-production GA4 property (dev build + localhost)
};
